const es = {
  // Navbar
  nav_home: "Inicio",
  nav_about: "Sobre Tenten-Ojisan",
  nav_services: "Servicios y Precios",
  nav_flow: "C\u00f3mo funciona",
  nav_testimonials: "Testimonios",
  nav_faq: "Preguntas frecuentes",
  nav_contact: "Contacto",
  nav_cta: "Reservar lectura",
  nav_subtitle: "Lectura de nombres \u00b7 Okinawa",
  nav_title: "Adivinaci\u00f3n Tenten-Ojisan",

  // Hero
  hero_headline1: "En una isla tranquila",
  hero_headline2: "de Okinawa",
  hero_headline3: "escucha la voz",
  hero_headline4: "de tu nombre.",
  hero_body: "Una popular lectura de nombres con meses de espera.\nCada mes viajo en tu nombre a la isla\ny entrego tu nombre personalmente al maestro.",
  hero_pill1: "Sin cambio de nombre",
  hero_pill2: "100% en l\u00ednea",
  hero_pill3: "Entrega en 1 mes",
  hero_pill4: "Primeros 100 por mes",
  hero_btn_apply: "Reservar lectura",
  hero_btn_services: "Ver servicios",
  hero_scroll: "DESPLAZAR",

  // About
  about_heading: "Sobre Tenten-Ojisan",
  about_intro: "En la tranquila isla de \u003cstrong\u003eIkei-jima\u003c/strong\u003e, envuelta por el suave mar de Okinawa,\nhay un hombre que a\u00f1ade silenciosamente algo de luz a cada nombre.\nLa gente lo llama con cari\u00f1o \u003cstrong\u003e\u201cTenten-Ojisan\u201d\u003c/strong\u003e.",
  about_block1_label: "De banquero a lector de nombres",
  about_block1_text: "Tenten-Ojisan era originalmente banquero.\nGracias a su dedicaci\u00f3n, se convirti\u00f3 en el \u003cstrong\u003egerente de sucursal m\u00e1s joven\u003c/strong\u003e de su empresa.\nTrabajando con muchas personas, surgi\u00f3 una pregunta en su coraz\u00f3n.",
  about_block1_quote: "\u201c\u00bfPor qu\u00e9 algunas personas parecen tener viento a favor, aunque todos trabajen igual de duro?\u201d",
  about_block1_sub: "Esa peque\u00f1a pregunta se convirti\u00f3 en el inicio de un gran viaje de descubrimiento.",
  about_block2_label: "Conocimiento antiguo y una revelaci\u00f3n silenciosa",
  about_block2_text: "Dedic\u00f3 cada momento libre al estudio de textos antiguos de lectura de nombres, investigando cuidadosamente el n\u00famero de trazos de los caracteres tradicionales y el flujo son\u00f3ro.",
  about_block2_text2: "Se dio cuenta de que \u003cstrong\u003e\u201elos Ten-ten (marcas de voz) pueden armonizar silenciosamente el flujo de un nombre.\u201d\u003c/strong\u003e",
  about_block2_sub: "No era magia dram\u00e1tica ni una f\u00f3rmula de \u00e9xito llamativa,\nsino un camino suave para hacer m\u00e1s visible la luz que ya existe en una persona.",
  about_block3_label: "Boca a boca \u2013 ahora 6 meses de espera",
  about_block3_text: "Sus suaves lecturas se difundieron puramente por boca a boca, y ahora \u003cstrong\u003ellegan solicitudes de todo Jap\u00f3n\u003c/strong\u003e.\nFamoso o no, trata a cada persona con el mismo cuidado.\nPone su mano sobre cada nombre y acompa\u00f1a la vida de esa persona.\nEse es el estilo de Tenten-Ojisan.",

  // Gallery
  gallery_heading: "Galer\u00eda",
  gallery_sub: "Okinawa \u00b7 Isla Ikei",

  // Services
  services_heading: "Servicios y Precios",
  services_note1: "\u203b Todas las tarifas incluyen los honorarios del maestro y nuestro servicio de representaci\u00f3n in situ.",
  services_note2: "\u203b Sin costos adicionales. Si\u00e9ntase libre de confiar en nosotros.",
  services_tab1: "Nombre personal",
  services_tab2: "Nombre comercial",
  services_tab3: "Nombre de mascota",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "Observamos suavemente el crecimiento, el entorno y los movimientos del coraz\u00f3n, y a\u00f1adimos el Ten-ten perfecto para usted.",
  services_tab2_desc: "Un suave viento a favor para nuevos desaf\u00edos. Armonizando suavemente el flujo de su negocio.",
  services_tab3_desc: "Para el miembro de la familia que siempre est\u00e1 a su lado. Entregamos un nombre lleno de paz y calidez.",
  services_row1_target1: "16 a\u00f1os o m\u00e1s",
  services_row1_target2: "4\u201315 a\u00f1os",
  services_row1_target3: "0\u20133 a\u00f1os",
  services_row2_target1: "Negocio / Empresa / Nombre comercial",
  services_row3_target1: "Nombre de mascota",
  services_col_target: "P\u00fablico objetivo",
  services_col_price: "Precio (IVA incl.)",
  services_cta: "Solicitar este servicio",
  services_includes_title: "Qu\u00e9 incluye (todo en el precio)",
  services_inc1: "Lectura de nombre",
  services_inc2: "Sugerencia \u00f3ptima de Ten-ten",
  services_inc3: "Tarjeta en formato tarjeta de visita por correo a pedido (gratis)",
  services_inc4: "Consejos de buena suerte",
  services_inc5: "Foto digital de la tarjeta de nombre",
  services_includes_note: "Una lectura para resaltar suavemente el encanto que ya existe en su nombre.",
  services_payment_title: "Pago",
  services_payment_method: "Transferencia bancaria (pago anticipado)",
  services_payment_desc: "Le proporcionaremos los datos bancarios despu\u00e9s de su solicitud.\nUna vez completado su pago, el flujo de buena suerte comienza a alinearse silenciosamente.",
  services_first_title: "Para nuevos visitantes",
  services_first_desc: "Es natural sentirse inseguro.\nEse sentimiento es una se\u00f1al de su coraz\u00f3n\nde que es hora de comenzar un cambio suave.",
  services_first_cta: "Comenzar con una consulta",

  // Flow
  flow_heading: "C\u00f3mo funciona",
  flow_step1_title: "Enviar formulario de solicitud",
  flow_step1_c1: "Por favor, complete la informaci\u00f3n requerida en el formulario designado.",
  flow_step1_c2: "Despu\u00e9s de enviar, recibir\u00e1 un correo electr\u00f3nico de respuesta en 2\u20133 d\u00edas h\u00e1biles.",
  flow_step1_c3: "El correo electr\u00f3nico incluir\u00e1 los pr\u00f3ximos pasos e instrucciones para la transferencia bancaria.",
  flow_step2_title: "Transferir la tarifa de lectura",
  flow_step2_c1: "Por favor, transfiera la tarifa de lectura a la cuenta indicada en el correo de respuesta.",
  flow_step2_c2: "Tras la confirmaci\u00f3n, comenzaremos a preparar su lectura en orden.",
  flow_step3_title: "Notificarnos sobre su transferencia",
  flow_step3_c1: "Despu\u00e9s de la transferencia, env\u00ede una foto de su comprobante a la direcci\u00f3n indicada en el correo.",
  flow_step3_c2: "Tras la confirmaci\u00f3n, le enviaremos un mensaje de \u201cRegistro completado\u201d.",
  flow_step3_note: "Sin esta notificaci\u00f3n, es posible que no podamos comenzar su lectura. Aseg\u00farese de enviarla.",
  flow_step4_title: "Recibir resultados de la lectura",
  flow_step4_c1: "Dentro de aproximadamente una semana despu\u00e9s de la lectura, le enviaremos por correo electr\u00f3nico una foto de su tarjeta de nombre con Ten-ten.",
  flow_step4_c2: "Luego enviaremos un informe detallado de la lectura y consejos de buena suerte por correo electr\u00f3nico.",
  flow_step5_title: "Env\u00edo de tarjeta de nombre (opcional)",
  flow_step5_c1: "A pedido, enviamos una tarjeta escrita a mano por el maestro en formato tarjeta de visita.",
  flow_step5_c2: "Por favor, indique su direcci\u00f3n postal exacta en el campo de direcci\u00f3n del formulario de solicitud.",
  flow_step5_note: "Si no necesita la tarjeta, basta con indicar su ciudad.",
  flow_banner_title: "Completamente en l\u00ednea. Desde cualquier lugar de Jap\u00f3n.",
  flow_banner_desc: "No es necesario viajar a la isla Ikei en Okinawa.\nPuede comenzar tal como est\u00e1, sin cambiar su rutina diaria.",
  flow_banner_cta: "Solicitar ahora",

  // Testimonials
  testimonials_heading: "Testimonios",
  testimonials_viewing: "Mostrando",

  // FAQ
  faq_heading: "Preguntas frecuentes",
  faq_cta_title: "\u00bfTiene m\u00e1s preguntas?",
  faq_cta_desc: "Incluso las cosas peque\u00f1as son bienvenidas.\nLas preguntas que duda en hacer son exactamente las que queremos escuchar.",
  faq_cta_btn: "Preg\u00fantenos",

  // CTA Banner
  cta_heading1: "Consulta",
  cta_heading2: "gratuita",
  cta_btn: "Reservar ahora",

  // Contact
  contact_heading: "Contacto",
  contact_desc: "Cont\u00e1ctenos a trav\u00e9s de este formulario para solicitudes de lectura o preguntas. Normalmente respondemos en 2\u20133 d\u00edas h\u00e1biles.",
  contact_address_label: "Direcci\u00f3n",
  contact_address_value: "Tochigi, Jap\u00f3n (En l\u00ednea \u00b7 Todo el pa\u00eds)",
  contact_email_label: "Correo electr\u00f3nico",
  contact_hours_label: "Horario",
  contact_hours_value: "L\u00fan\u2013Vie 9:00\u201318:00 (S\u00e1b/Dom/Festivos cerrado)",
  contact_note_title: "Sobre las respuestas",
  contact_note_desc: "Nuestra respuesta podr\u00eda llegar a su carpeta de spam.\nSi no ha recibido respuesta en 2\u20133 d\u00edas h\u00e1biles, cont\u00e1ctenos directamente por correo electr\u00f3nico.",
  contact_field_name: "Nombre completo",
  contact_field_furigana: "Furigana (lectura)",
  contact_field_email: "Direcci\u00f3n de correo electr\u00f3nico",
  contact_field_phone: "N\u00famero de tel\u00e9fono",
  contact_field_service: "Servicio deseado",
  contact_field_message: "Mensaje",
  contact_placeholder_name: "Juan P\u00e9rez",
  contact_placeholder_furigana: "\u30e4\u30de\u30c0 \u30bf\u30ed\u30a6",
  contact_placeholder_email: "ejemplo@correo.com",
  contact_placeholder_phone: "+34 000 000 000",
  contact_placeholder_message: "Por favor, ingrese el nombre que desea leer, o sus preguntas y deseos.",
  contact_select_placeholder: "Por favor, seleccione",
  contact_service1: "Nombre personal",
  contact_service2: "Nombre comercial",
  contact_service3: "Nombre de mascota",
  contact_service4: "Otro / Consulta",
  contact_submit: "Enviar",
  contact_submitting: "Enviando...",
  contact_privacy: "Los datos personales enviados se utilizar\u00e1n \u00fanicamente para los servicios de lectura.",
  contact_error: "Error al enviar. Por favor, int\u00e9ntelo de nuevo m\u00e1s tarde o cont\u00e1ctenos directamente por correo electr\u00f3nico.",
  contact_err_name: "Por favor, ingrese su nombre",
  contact_err_email_required: "Por favor, ingrese su direcci\u00f3n de correo electr\u00f3nico",
  contact_err_email_invalid: "Por favor, ingrese una direcci\u00f3n de correo electr\u00f3nico v\u00e1lida",
  contact_err_service: "Por favor, seleccione un servicio",
  contact_err_message_required: "Por favor, ingrese su mensaje",
  contact_err_message_limit: "Por favor, limite su mensaje a 500 caracteres",
  contact_thanks_title: "Mensaje enviado",
  contact_thanks_desc: "Gracias por contactarnos.\nRevisaremos su mensaje y responderemos en \u003cstrong\u003e2\u20133 d\u00edas h\u00e1biles\u003c/strong\u003e.\nPor favor, tenga un poco de paciencia.",
  contact_thanks_check1: "Por favor, revise su correo de confirmaci\u00f3n",
  contact_thanks_check2: "Revise tambi\u00e9n su carpeta de spam",
  contact_thanks_check3: "Por favor, espere 2\u20133 d\u00edas h\u00e1biles para una respuesta",
  contact_thanks_another: "Enviar otro mensaje",

  // Footer
  footer_subtitle: "Lectura de nombres \u00b7 Okinawa",
  footer_title: "Adivinaci\u00f3n Tenten-Ojisan",
  footer_desc: "Desde Okinawa a todo Jap\u00f3n. Un maestro de lectura de nombres con m\u00e1s de 50 a\u00f1os de experiencia lee cuidadosamente el destino en su nombre.",
  footer_contact_title: "INFORMACI\u00d3N DE CONTACTO",
  footer_address_label: "DIRECCI\u00d3N",
  footer_address_value: "Tochigi, Jap\u00f3n\n(En l\u00ednea \u00b7 Todo el pa\u00eds)",
  footer_email_label: "CORREO",
  footer_hours_label: "HORARIO",
  footer_hours_value: "L\u00fan\u2013Vie 9:00\u201318:00\n(S\u00e1b/Dom/Festivos cerrado)",
  footer_nav_title: "NAVEGACI\u00d3N",
  footer_copyright: "\u00a9 2025 Adivinaci\u00f3n Tenten-Ojisan. Todos los derechos reservados.",
  footer_privacy: "Pol\u00edtica de privacidad",
  footer_law: "Ley de transacciones comerciales especificadas",
  footer_sitemap: "Mapa del sitio",
};

export default es;
